module.exports = __webpack_public_path__ + "img/loader-green.3f026354.svg";